import AxiosInstance from "../services/networkServices";

// auth apis
export const login = (data) => AxiosInstance.post(`/api/admin/login`, data);
export const logout = (data) => AxiosInstance.post(`/auth/logout`, data);
export const forgotPassword = (data) =>
  AxiosInstance.post(`/api/admin/forgot-password`, data);
export const changePassword = (data) =>
  AxiosInstance.post(`/api/admin/change-password`, data);
export const resetPassword = (data) =>
  AxiosInstance.post(`/api/admin/reset-password`, data);

// manage users apis
export const getUsers = (userType, search, nextId) =>
  AxiosInstance.get(
    `/admin/list-users?role=${userType}${search ? `&search=${search}` : ""}${nextId ? `&nextId=${nextId}` : ""
    }`
  );
export const getUserDetail = (id) =>
  AxiosInstance.get(`/admin/view-user/${id}`);
export const inviteUser = (data) =>
  AxiosInstance.post(`/admin/invite-user`, data);
export const createUser = (data) =>
  AxiosInstance.post(`/admin/create-user`, data);
export const updateStatus = (id) =>
  AxiosInstance.patch(`/admin/block-unblock-user/${id}`);

// settings apis
export const updateProfile = (payload) => AxiosInstance.post(`/api/admin/update-profile`, payload);
export const getProfile = (data) => AxiosInstance.get(`/user`, data);
export const viewProfile = () => AxiosInstance.get(`/api/admin/view-profile`);
export const getVerifyEmailOtp = (payload) => AxiosInstance.post(`/api/admin/resend-otp`, payload);
export const verifyOtp = (payload) => AxiosInstance.post(`/api/admin/verify-email`, payload);

//manage categories apis
export const getCategoryList = (category, page) => AxiosInstance.get(`/api/admin/list-category?type=${category}&page=${page}&limit=10`);
export const deleteCategory = (titleId) => AxiosInstance.delete(`/api/admin/delete-category/${titleId}`);
export const createCategory = (payload) => AxiosInstance.post("/api/admin/add-category", payload)
export const updateCategory = (payload) => AxiosInstance.patch("/api/admin/update-category", payload)

//manage appdata
// FAQ
export const getFaqList = (page) => AxiosInstance.get(`/api/admin/list-faq?page=${page}&limit=10`)
export const addFaq = (payload) => AxiosInstance.post(`/api/admin/add-faq`, payload)
export const editFaq = (payload) => AxiosInstance.patch(`/api/admin/update-faq`, payload)
export const deleteFaq = (faqId) => AxiosInstance.delete(`/api/admin/delete-faq/${faqId}`)

//sponsor
export const addSponsor = (payload) => AxiosInstance.post(`/api/admin/add-sponsor`, payload)
export const listSponsor = (page) => AxiosInstance.get(`/api/admin/list-sponsor?page=${page}&limit=10`)
export const deleteSponsor = (sponsorId) => AxiosInstance.delete(`/api/admin/delete-sponsor/${sponsorId}`)
export const updateSponsor = (payload) => AxiosInstance.patch(`/api/admin/update-sponsor`, payload)

//resources
export const addResource = (payload) => AxiosInstance.post(`/api/admin/add-resource`, payload)
export const listResource = (page) => AxiosInstance.get(`/api/admin/list-resource?page=${page}&limit=10`)
export const deleteResource = (resourceId) => AxiosInstance.delete(`/api/admin/delete-resource/${resourceId}`)
export const updateResource = (payload) => AxiosInstance.patch(`/api/admin/update-resource`, payload)

// help and support
export const listHelpNSupport = (page) => AxiosInstance.get(`/api/support/list-support?page=${page}&limit=10`)
export const sendReply = (payload) => AxiosInstance.post(`/api/support/reply-support`, payload)

//common
export const addFile = (payload) => AxiosInstance.post(`/api/file/upload`, payload)
export const deleteFile = (payload) => {
  const config = {};
  config.data = payload; // Axios uses 'data' for the request payload
  return AxiosInstance.delete(`/api/file/delete`, config);
};